import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Games.css';

const rounds = [
  {
    scenario: 'Students are overwhelmed by tracking assignment deadlines.',
    options: ['NFT marketplace', 'Deadline planner app', 'Luxury watch brand'],
    answer: 'Deadline planner app',
  },
  {
    scenario: 'Small vendors struggle to showcase products online quickly.',
    options: ['Digital storefront template', 'VR racing game', 'Premium perfume box'],
    answer: 'Digital storefront template',
  },
  {
    scenario: 'Freelancers lose clients due to late invoice follow-ups.',
    options: ['Invoice reminder bot', 'Fitness smartwatch', 'Photo filter pack'],
    answer: 'Invoice reminder bot',
  },
];

const IdeaMatchGame = () => {
  const [index, setIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [picked, setPicked] = useState('');
  const [completed, setCompleted] = useState(false);

  const current = rounds[index];
  const feedback = useMemo(() => {
    if (!picked) return '';
    return picked === current.answer ? 'Correct match. Great customer focus.' : 'Not quite. Prioritize solving the pain point directly.';
  }, [picked, current]);

  const handlePick = (option) => {
    if (picked) return;
    setPicked(option);
    if (option === current.answer) {
      setScore((prev) => prev + 100);
    }
  };

  const nextRound = () => {
    if (index === rounds.length - 1) {
      setCompleted(true);
      return;
    }
    setIndex((prev) => prev + 1);
    setPicked('');
  };

  const restart = () => {
    setIndex(0);
    setScore(0);
    setPicked('');
    setCompleted(false);
  };

  return (
    <main className="game-shell">
      <header className="game-header">
        <h1>Idea Match</h1>
        <p>Round {Math.min(index + 1, rounds.length)} of {rounds.length}</p>
      </header>

      {!completed && (
        <section className="game-card">
          <h2>Customer Problem</h2>
          <p>{current.scenario}</p>
          <div className="game-options">
            {current.options.map((option) => (
              <button
                type="button"
                key={option}
                className="game-option"
                onClick={() => handlePick(option)}
                disabled={Boolean(picked)}
              >
                {option}
              </button>
            ))}
          </div>
          {picked && <p className="game-feedback">{feedback}</p>}
          {picked && (
            <button type="button" className="game-btn" onClick={nextRound}>
              {index === rounds.length - 1 ? 'See Result' : 'Next Round'}
            </button>
          )}
        </section>
      )}

      {completed && (
        <section className="game-card">
          <h2>Great effort.</h2>
          <p>Your score: {score} / 300</p>
          <div className="game-row">
            <button type="button" className="game-btn" onClick={restart}>Play Again</button>
            <Link to="/games" className="game-link">Back to Games</Link>
          </div>
        </section>
      )}
    </main>
  );
};

export default IdeaMatchGame;
